"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A styled heading component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} styled heading
 */
function StyledHeading(props) {
  if (!props.rendering.fields) {
    return null;
  }
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var StyleContent = props => {
    if (props.Divider.value === 'Default') {
      return (0, _titleHeadTag.headTagTitle)(props.Title, 'mm-section', props.TitleSize.value);
    } else if (props.Divider.value === 'Simple') return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("hr", null));else return /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-section"
    }, props.Title.value);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "mm-spacing--minor styled-heading"
  }, /*#__PURE__*/_react.default.createElement(StyleContent, extractedFields));
}
var _default = exports.default = StyledHeading;